import React from 'react';
import { useLocale } from '../context/localeContext';

const LocaleTabs: React.FC<{ enabled?: boolean }> = ({ enabled = true }) => {
  const { availableLocales, fallbackLocale, activeLocale, setActiveLocale } = useLocale();
  
  const filteredLocales = [fallbackLocale, ...availableLocales.filter((locale) => locale !== fallbackLocale)];

  if (!enabled || filteredLocales.length <= 1) return null;

  return (
    <div className="border-b border-gray-200">
      <nav className="-mb-px flex space-x-8" aria-label="Tabs">
        {filteredLocales.map((locale) => (
          <button
            key={locale}
            onClick={() => setActiveLocale(locale)}
            className={`${
              locale === activeLocale
                ? 'border-indigo-500 text-indigo-600'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm focus:outline-none`}
          >
            {locale.toUpperCase()}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default LocaleTabs;